import { render } from "./advertisingSpace.vue?vue&type=template&id=03de6b20&scoped=true"
import script from "./advertisingSpace.vue?vue&type=script&lang=js"
export * from "./advertisingSpace.vue?vue&type=script&lang=js"

import "./advertisingSpace.vue?vue&type=style&index=0&id=03de6b20&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03de6b20"]])

export default __exports__